module.exports = __webpack_public_path__ + "front/img/b47.7ce67f3b.jpg";